import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-faq',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {
  readonly faqs = [
    {
      question: 'faq.items.transit_times.question',
      answer: 'faq.items.transit_times.answer',
    },
    {
      question: 'faq.items.perishables.question',
      answer: 'faq.items.perishables.answer',
    },
  ];
}
